import {
  Component,
  input,
  OnChanges,
  OnInit,
  output,
  SimpleChanges,
  viewChild
} from '@angular/core';

import { AsyncPipe, CommonModule, DecimalPipe, NgTemplateOutlet, TitleCasePipe, UpperCasePipe } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import {
  PostingHistoryModalComponent
} from '../../../shared/components/offer-modals/posting-history-modal/posting-history-modal.component';
import { RouterLink } from '@angular/router';
import {
  SharedListMultiActionModalComponent
} from '../../../shared/components/offer-modals/shared-list-multi-action-modal/shared-list-multi-action-modal.component';
import {
  StateIndicatorComponent
} from '../../../shared/components/state-indicator/state-indicator.component';
import {
  TooltipComponent,
  TrackButtonDirective,
  TrapFocusComponent
} from 'remarketing-ui-components-lib';
import { VehicleCardComponent } from '../vehicle-card/vehicle-card.component';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
  AddVehicleUuidToSelections,
  ClearAllSelectedVehicles,
  ClearAllSelectedVehiclesUuid,
  ConfigurationState,
  InventoryManagementAuctionItemStatus,
  StatusFilter
} from 'remarketing-angular-library';
import {
  ActionListMessageModalComponent
} from '../action-list-modals/action-list-message-modal/action-list-message-modal.component';
import {
  EditListingGroundModalComponent
} from '../edit-listing-ground-modal/edit-listing-ground-modal.component';
import {
  MakeUnreserveModalComponent
} from '../action-list-modals/make-unreserve-modal/make-unreserve-modal.component';
import {
  MakeReserveModalComponent
} from '../action-list-modals/make-reserve-modal/make-reserve-modal.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { take } from 'rxjs/operators';
import {
  PurchaseOfferHistoryModalComponent
} from '../action-list-modals/purchase-offer-history-modal/purchase-offer-history-modal.component';

@Component({
  selector: '[app-list-view-inventory-item]',
  imports: [
    A11yModule,
    ActionListMessageModalComponent,
    AsyncPipe,
    DecimalPipe,
    EditListingGroundModalComponent,
    MakeReserveModalComponent,
    MakeUnreserveModalComponent,
    NgTemplateOutlet,
    PostingHistoryModalComponent,
    PurchaseOfferHistoryModalComponent,
    RouterLink,
    SharedListMultiActionModalComponent,
    StateIndicatorComponent,
    TitleCasePipe,
    TooltipComponent,
    PopoverModule,
    TrackButtonDirective,
    TrapFocusComponent,
    UpperCasePipe,
    CommonModule
],
  templateUrl: './list-view-inventory-item.component.html',
  styleUrl: './list-view-inventory-item.component.scss'
})
export class ListViewInventoryItemComponent extends VehicleCardComponent implements OnInit {
  readonly editListingGroundDataTrack = 'editListingGround';
  readonly changeReservedDealershipDataTrack = 'changeReservedDealership';
  readonly unreserveDataTrack = 'unreserve';
  readonly reserveDataTrack = 'reserve';
  readonly acceptDataTrack = 'accept';
  readonly counterDataTrack = 'counter';
  readonly declineDataTrack = 'decline';
  readonly withdrawDataTrack = 'withdraw';
  private readonly IN_SERVICE_VEHICLE = 'ISV';

  readonly noValueIndicator = '- -';

  readonly singleListSelected$ = input.required<boolean>();
  readonly hadMultiOfferActionSuccess$ = input.required<boolean>();
  readonly isFilterByInServiceVehicles$ = input(false);

  readonly modalEvent = output<any>();

  readonly popover$ = viewChild<any>('kabobPopOver');
  readonly sharedListMultiActionModal$ = viewChild.required<SharedListMultiActionModalComponent>(SharedListMultiActionModalComponent);
  readonly editListingGroundModal$ = viewChild.required<EditListingGroundModalComponent>(EditListingGroundModalComponent);
  readonly purchaseOfferHistoryModal$ = viewChild.required<PurchaseOfferHistoryModalComponent>(PurchaseOfferHistoryModalComponent);
  readonly postingHistoryModal$ = viewChild.required<PostingHistoryModalComponent>(PostingHistoryModalComponent);

  isPopoverOpen = false;
  protected modalMessage: Map<string,string[]>;
  modalRef: BsModalRef;
  modalConfig: any;
  userType = 'SELLER';
  hadOfferActionTaken: boolean;
  protected tenantName = '';
  analyticsObject = {
    reserve: {
      buttonName: 'Reserve',
      modalName: 'Reserve Vehicle Modal'
    },
    changeReserved: {
      buttonName: 'Change Reserved Dealership',
      modalName: 'Reserve Vehicle Modal'
    },
    unreserve: {
      buttonName: 'Unreserve',
      modalName: 'Unreserve Vehicle Modal'
    }
  };

  // not used?
 // inventoryManagementAuctionItemStatusEnum = InventoryManagementAuctionItemStatus;

  // not used?
  // vehicleIsGrounded: boolean;

  setIsPopoverOpen(value: boolean): void {
    this.isPopoverOpen = value;
    if (value) {
      // Manually focus the close button with preventScroll to avoid scroll jump
      setTimeout(() => {
        const popoverElement = document.querySelector('.list-view-actions-popover');
        if (popoverElement) {
          // Target the close button specifically
          const closeButton = popoverElement.querySelector<HTMLElement>('#close_x_button');
          if (closeButton) {
            closeButton.focus({ preventScroll: true });
          }
        }
      }, 0);
    }
  }

  closePopover() {
    this.popover$().hide();
  }

  auctionItemStatusEqualTo(status: InventoryManagementAuctionItemStatus) {
    return this.auctionItemSell$().auctionItemStatus === status;
  }

  groundedValueChanged(event) {
    const groundedDate = event.data.inventoryItem.groundedDate;
    groundedDate ? this.groundedSubject.next(true) : this.groundedSubject.next(false);
  }

  get isInspectionSeriesEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('platform-inspectionSeriesEnabled', false);
  }

  get isChangeReservedDealershipEnabled() {
    return this.launchDarklyService.getFeatureFlag('sell-changeReservedDealerEnabled', false);
  }

  get totalPrice() {
    if(this.isTotalPriceValuesPresent) {
      const mainPrice = this.auctionItemSell$()?.salePrice
        ? this.auctionItemSell$().salePrice : this.auctionItemSell$()?.offerAmount;

      const feesPrice = this.auctionItemSell$()?.buyFee?.total;

      return feesPrice !== undefined && feesPrice !== null  ? (mainPrice + feesPrice) : mainPrice;
    } else {
      return undefined;
    }
  }

  get isTotalPriceValuesPresent() : boolean {
    return !!this.auctionItemSell$()?.salePrice || !!this.auctionItemSell$()?.offerAmount;
  }

  get showQuestionsValue() {
    if (!this.isVehicleTypeFilterISV) {
      return (
        this.inventoryCurrentStatus$() === StatusFilter.ACTIVE_VEHICLES ||
        (this.inventoryCurrentStatus$() === StatusFilter.SHARED_VEHICLES &&
          this.auctionItemSell$().auctionItemStatus === this.vehicleStatusFilter.ACTIVE)
      );
    }
    return true;
  }

  get showOffersValue() {
    if (!this.isVehicleTypeFilterISV) {
      return (
        this.inventoryCurrentStatus$() === StatusFilter.ACTIVE_VEHICLES ||
        (this.inventoryCurrentStatus$() === StatusFilter.SHARED_VEHICLES &&
          this.auctionItemSell$().auctionItemStatus === this.vehicleStatusFilter.ACTIVE)
      );
    }
  }

  get showHighestOfferValue() {
    if (!this.isVehicleTypeFilterISV) {
      return this.auctionItemSell$().auctionItemStatus === this.vehicleStatusFilter.ACTIVE && this.highestOffer;
    }
  }

  get showBuyNowValue() {
    if (!this.isVehicleTypeFilterISV) {
      return (
        this.auctionItemSell$().auctionItemStatus === this.vehicleStatusFilter.ACTIVE && this.auctionItemSell$().buyNowAmount
      );
    }
  }

  get showOpeningPriceValue(): boolean {
    return !this.isVehicleTypeFilterISV
      ? this.auctionItemSell$().auctionItemStatus === this.vehicleStatusFilter.ACTIVE
      : this.auctionItemSell$().auctionItemStatus === this.vehicleStatusFilter.ACTIVE ||
          this.auctionItemSell$().auctionItemStatus === this.vehicleStatusFilter.RESERVED ||
          this.auctionItemSell$().auctionItemStatus === this.vehicleStatusFilter.SOLD ||
          this.auctionItemSell$().auctionItemStatus === this.vehicleStatusFilter.HOLD ||
          this.auctionItemSell$().auctionItemStatus === this.vehicleStatusFilter.REMOVED;
  }

  get showSaleFeeAndSalePriceColumn() {
    if (!this.isVehicleTypeFilterISV) {
      return (
        this.inventoryCurrentStatus$() === StatusFilter.SHARED_VEHICLES ||
        this.inventoryCurrentStatus$() === StatusFilter.SOLD_VEHICLES
      );
    }
  }

  get showSaleFeeAndSalePriceValue() {
    return this.auctionItemSell$().auctionItemStatus === this.vehicleStatusFilter.SOLD && this.auctionItemSell$().salePrice;
  }

  get showTotalPriceValue() {
    return this.auctionItemSell$()?.salePrice || this.auctionItemSell$()?.offerAmount;
  }

  get showTotalPriceColumn() {
    if (!this.isVehicleTypeFilterISV) {
      return this.inventoryCurrentStatus$() === StatusFilter.SHARED_VEHICLES && this.singleListSelected$();
    }
  }


  get showActionsDropdown() {
    return (
      this.auctionItemSell$().auctionItemStatus !== this.vehicleStatusFilter.EXPIRED &&
      this.auctionItemSell$().auctionItemStatus !== this.vehicleStatusFilter.REMOVED &&
      this.auctionItemSell$().auctionItemStatus !== this.vehicleStatusFilter.HOLD
    );
  }

  get showListViewCheckbox() {
    return this.showActionBarCheckbox && !this.hadMultiOfferActionSuccess$();
  }

  get showGroundedColumn() {
    return this.inventoryCurrentStatus$() === StatusFilter.RESERVED_VEHICLES;
  }

  ngOnInit() {
    super.ngOnInit();
    this.getTenantName();
  }

  showOfferActionButton(offerAction) {
    return this.sellerActionMapCounter.get(offerAction) === 1;
  }

  showPurchaseOfferHistoryModal() {
    this.purchaseOfferHistoryModal$().show();
  }

  showPostingHistoryModal() {
    this.postingHistoryModal$().show();
  }

  get showListViewPostingHistoryButton(): boolean {
    return this.isRemovedActionsEnabled && this.auctionItemSell$()?.removalCount > 1;
  }

  get showListViewRepostButton(): boolean {
    return this.isRemovedActionsEnabled && !this.auctionItemSell$().repostedDate && !this.isVinDecodeRequired();
  }

  get showListViewActionsDropdown(): boolean {
    if (this.inServiceVehiclesEnabled) {
      return this.isInServiceVehicle && this.isNotSoldOrRemoved;
    } else {
      return this.showActionElipsisForGenericTenantVehicle;
    }
  }

  get isInServiceVehicleOrReservationsEnabled(): boolean {
    return this.inServiceVehiclesEnabled || this.isReservationsEnabled;
  }

  get isInServiceVehicle(): boolean {
    return this.auctionItemSell$()?.vehicleTypeCode === this.IN_SERVICE_VEHICLE;
  }

  get isNotSoldOrRemoved(): boolean {
    const auctionItemStatus = this.auctionItemSell$()?.auctionItemStatus;
    return (
      auctionItemStatus !== this.vehicleStatusFilter.SOLD &&
      auctionItemStatus !== this.vehicleStatusFilter.REMOVED &&
      auctionItemStatus !== this.vehicleStatusFilter.EXPIRED
    );
  }

  get isReserved(): boolean {
    const reservationDate = this.auctionItemSell$()?.reservation?.reservedAt;
    return reservationDate !== null && reservationDate !== undefined && reservationDate.length > 0;
  }

  get showActionElipsisForGenericTenantVehicle(): boolean {
    if (
      this.auctionItemStatusEqualTo(this.vehicleStatusFilter.REMOVED) ||
      this.auctionItemStatusEqualTo(this.vehicleStatusFilter.EXPIRED)
    ) {
      return this.showListViewPostingHistoryButton || this.showListViewRepostButton;
    }
    return true;
  }

  get reserveStatus() {
    return this.listViewTableTranslations.textReserve;
  }

  get isSellUpdateInventoryFeatureEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('sell-updateInventoryEnabled', false);
  }

  get highestOfferValue(): string {
    return this.auctionItemSell$()?.highestOffer ?
      this.formatCurrency(this.auctionItemSell$().highestOffer) : this.noValueIndicator;
  }

  get historicalHighValue(): string {
    const value = this.auctionItemSell$()?.highestHistoricalOffer;
    return value ? this.formatCurrency(value) : this.noValueIndicator;
  }

  get buyNowAmountValue(): string {
    return this.auctionItemSell$()?.buyNowAmount ?
      this.formatCurrency(this.auctionItemSell$()?.buyNowAmount) : this.noValueIndicator;
  }

  get openingPriceValue(): string {
    return this.auctionItemSell$()?.currentAmount ?
      this.formatCurrency(this.auctionItemSell$()?.currentAmount) : this.noValueIndicator;
  }

  get sellFeesTotalAmountValue(): string {
    return this.auctionItemSell$()?.sellFee?.total ?
      this.formatCurrency(this.auctionItemSell$().sellFee.total, true) : this.noValueIndicator;
  }

  get salePriceValue(): string {
    return  this.auctionItemSell$()?.salePrice
      ? this.formatCurrency(this.auctionItemSell$().salePrice) : this.noValueIndicator;
  }

  get totalPriceValue(): string {
    return  this.isTotalPriceValuesPresent
      ? this.formatCurrency(this.totalPrice) : this.noValueIndicator;
  }

  showMultiActionModal(modalType: string) {
    this.sharedListMultiActionModal$().show(modalType, [this.auctionItemSell$()], true);
    this.closePopover();
  }

  showEditListingGroundModal(modalType: string) {
    this.editListingGroundModal$().show(modalType, this.auctionItemSell$());
    this.closePopover();
  }

  createBanners(event) {
    this.sharedListMultiActionModal$().close();
    this.modalEvent.emit(event);
  }

  formatStorageLocation() {
    if (this.auctionItemSell$().storageLocation?.city && this.auctionItemSell$().storageLocation?.state) {
      const city = this.auctionItemSell$().storageLocation.city;
      const state = this.auctionItemSell$().storageLocation.state;
      return city + ', ' + state;
    } else {
      return null;
    }
  }

  openModal(template, analyticsTranslations) {
    this.store.dispatch([new ClearAllSelectedVehiclesUuid(), new AddVehicleUuidToSelections(this.auctionItemSell$())]);

    if (analyticsTranslations.buttonName) {
      this._analyticsService.fireEventOnButtonClick(analyticsTranslations.buttonName);
    }

    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.modalConfig = {
      class: 'modal--manage-inventory-action',
      backdrop: 'static',
      keyboard: false
    };

    this.modalRef = this.bsModalService.show(template, this.modalConfig);

    this.trackModalView(`${this.tenantName}: ${analyticsTranslations.modalName}`);
    this.closePopover();
  }

  onModalMessage($event, template) {
    this.modalMessage = $event;
    this.modalRef.hide();
    this.modalConfig = {
      class: 'modal--manage-inventory-action',
      backdrop: 'static',
      keyboard: false
    };
    this.modalRef = this.bsModalService.show(template, this.modalConfig);
  }

  onModalClose() {
    this.modalRef.hide();
    this.modalRef.onHide?.pipe(take(1)).subscribe(() => {
      this.store.dispatch(new ClearAllSelectedVehiclesUuid());
    });
  }

  getTenantName() {
    this.tenantName = this.store.selectSnapshot(ConfigurationState.tenantName);
  }

  trackModalView(modalName) {
    try {
      this._analyticsService.track('modalView', modalName);
    } catch(e) {
      console.error(e);
    }
  }
}
